import getFeatureFlags from "@/src/utils/feature-flag";

import { sendListingViewAction } from "../services/actions-tracker";

export const trackListingViewAction = async ({ actionName, baseUrl, queryParams = "" }) => {
  const flagStr = window?.env?.EJ_APPS_FEATURE_CONTROL || "0000000000";
  const { isEnabled } = getFeatureFlags(flagStr);

  if (!isEnabled("listing_view")) return;

  const userIdentifier = localStorage.getItem("taboola global:user-id");

  const userId = (() => {
    const userData = localStorage.getItem("user-data");
    try {
      return userData ? parseInt(JSON.parse(userData)?.id, 10) : undefined;
    } catch {
      return undefined;
    }
  })();

  try {
    await sendListingViewAction({
      memberId: userId,
      userIdentifier,
      actionName,
      baseUrl,
      queryParams,
    });
  } catch (error) {
    console.error("Action tracking failed:", error);
  }
};
